import * as React from 'react';
import { ValidationItem } from 'franke-trough-dependencies';

export interface AccordionItemProps {
  children: JSX.Element;
  error?: ValidationItem;
  btnName?: string;
}

export const AccordionItem: React.SFC<AccordionItemProps> = (props: AccordionItemProps) => {
  return ( 
    <div className="accordion-item-content">
      {props.children}
    </div>
  );
};

export default AccordionItem;